import { Grid } from 'antd';

const { useBreakpoint } = Grid;

export const useGetScreenSize = () => {
	/*
	Break points
	xs: '480px'
	sm: '576px'
	md: '768px',
	lg: '992px'
	xl: '1200px'
	xxl: '1600px'
	*/

	const { xxl, xl, lg, md, sm, xs } = useBreakpoint();

	return {
		isExtraExtraLarge: xxl,
		isExtraLarge: !xxl && xl,
		isLargeScreen: !xl && lg,
		isMediumScreen: !lg && md,
		isSmallScreen: !md && sm,
		isExtraSmallScreen: xs,
	};
};
